module.exports = __webpack_public_path__ + "static/media/rabbit.de8b7b6e.svg";